module.exports = {
  finance_inputBusinessNumber: 'Please input business number',
  finance_query: 'Query',
  finance_view: 'View',
  finance_returnQuery: 'Return Query',
  finance_batchAudit: 'Batch Audit',
  finance_lockTheBill: 'Lock The Bill',
  finance_accrue: 'Accrue',
  finance_businessCommission: 'business Commission',
  finance_cancelAccrue: 'Cancel Accrue',
  finance_print: 'Print',
  finance_audit: 'Audit',
  finance_cancelTheAudit: 'Cancel The Audit',
  finance_chargesAudit: 'Charges Audit',
  finance_cancelTheChargesAudit: 'Cancel The Charges Audit',
  finance_printTheProfit: 'Print The Profit',
  finance_editFinancialDate: 'Edit Financial Date',
  finance_businessAdjustment: 'Business Adjustment',
  finance_editChargeFinancialDate: 'Edit Charge Financial Date',
  finance_basic: 'Basic',
  finance_booking: 'Booking',
  finance_charges: 'Charges',
  finance_domesticBill: 'Domestic Bill',
  finance_internationalBill: 'International Bill',
  finance_collectAndPrepaid: 'Collect And Prepaid',
  finance_fileHistory: 'File History',
  finance_exportExcelAll: 'ExportExcelAll',
  finance_updateBusinessDate: 'Edit Business Date',
  finance_log: 'Log',
  finance_allowChange: 'Allow Change',
  finance_checkChange: 'Check Change',
  finance_batchCheckChange: 'Batch Check Change',
  finance_revokeChangeCommit: 'Revoke Change Commit',
  charge_receivables: 'Receivables',
  charge_equivalent: 'Equivalent',
  charge_inviteToConfirmTheCharges: 'Invite To Confirm The Charges',
  charge_newAdjustment: 'New Adjustment',
  charge_editAdjustment: 'Edit Adjustment',
  charge_deleteAdjustment: 'Delete Adjustment',
  charge_writeOffList: '消込明細',
  charge_chargesReject: 'Reject',
  charge_chargeItem: 'チャージ項目',
  charge_settleAccountsTo: '決算先',
  charge_invoiceHeader: '請求書社名',
  charge_somesticOrInternational: '帳簿種類',
  charge_drawABillOrNot: 'Draw A Bill Or Not',
  charge_currency: '通貨',
  charge_localCurrency: 'Local Currency',
  charge_conversionRMB: 'Conversion of Renminbi',
  charge_exchangeRate: '為替レート',
  charge_unit: '単位',
  charge_amount: '数量',
  charge_unitPrice: '単価',
  charge_taxIncludedPrice: '税込み金額',
  charge_taxExcludedPrice: '税抜き金額',
  charge_taxRate: '税率',
  charge_whtTaxRate: 'WHT税率',
  charge_payables: 'Payables',
  charge_controlled: '管理対象（または：制御中）',
  charge_cancelControlled: 'Cancel Controlled',
  charge_taxAmount: '税金',
  charge_whtTaxAmount: 'WHT税金',
  charge_whtTaxLocalAmount: 'WHT税金（local currency）',
  charge_notWhtAmount: 'Excluding WHT amount',
  charge_remarks: '備考',
  charge_contactPerson: '連絡先',
  charge_relatedBLNo: '関連BL番号',
  charge_relatedContainerNo: 'Associated box number',
  charge_freightCollectOrPrepaid: '費用ターム',
  charge_status: '状態',
  charge_confirmOrNot: 'Confirm or not',
  charge_billNo: '請求番号',
  charge_agent_billNo: 'Agent Shared Bill No',
  charge_containerNo: 'Container No',
  charge_invoiceNo: 'インボイス番号',
  charge_invoiceDate: '請求日',
  charge_agentBillNo: 'Agent Bill No',
  charge_theAmountOfWriteOffs: 'Clearance Amount',
  charge_writeOffDate: 'Clearance Date',
  charge_financialDate: '会計処理日',
  charge_businessNumber: '業務番号',
  charge_creator: '作成者',
  charge_createTime: 'Create Time',
  charge_editor: 'Editor',
  charge_editTime: 'Edit Time',
  charge_paymentApplicationNo: 'Payment Application No',
  charge_profit: 'Profit',
  charge_profitAll: 'Profit All',
  charge_locked_status: ' ロック状態',
  // charge_equivalent: 'Equivalent',
  charge_estimateRemarks: 'Estimate Remarks',
  charge_showRedCharges: 'Show Red Charges',
  charge_auditor: '編集者',
  charge_estimate: 'Estimate',
  charge_add: '新規追加',
  charge_copy: '前回費用コピー',
  charge_delete: '削除',
  charge_edit: 'edit',
  charge_chargesAudit: 'Charges Audit',
  charge_cancelTheAudit: 'cancel The Audit',
  charge_showCommonCharge: 'Show Common Charges',
  charge_showSpecialCharge: 'Show Special Charges',
  charge_sp1: 'Tariff No',
  charge_sp2: 'Click and copy tariff No',
  charge_sp3: 'Add by service',
  charge_sp4: '為替更新',
  charge_sp5: 'Copy receipt charge',
  charge_sp6: '買掛費用転用',
  charge_sp7: '費用プラン',
  charge_sp8: '運賃表',
  charge_sp9: 'Unsubmit',
  charge_sp10: 'Submit',
  charge_sp11: 'Split the charge',
  charge_sp12: 'Show HBL charge',
  charge_sp13: 'Service item',
  charge_copyCost: 'Copy AR',
  charge_copyCharge: '履歴転用',
  charge_payReceiveDate: '入出金日',
  charge_actualAmountNo: 'ActualAmountNo',
  charge_newChange: 'Add amendment fee',
  charge_editChange: 'Edit amendment fee',
  charge_deleteChange: 'Delete Change',
  charge_shared: 'Shared Charge',
  charge_showSharedCharges: 'Show Shared Charge',
  charge_newSpecial: 'New Special',
  charge_editSpecial: 'Edit Special',
  charge_unitPriceIncludeTax: 'Does unit price include tax',
  domestic_showAllBill: 'Show All Billings',
  domestic_commissionedChargesOnly: 'Show this Commissioned charges only',
  domestic_newReceivables: '新規収入',
  domestic_newPayables: '新規仕入先',
  domestic_edit: '編集',
  domestic_delete: '削除',
  domestic_view: '見る',
  domestic_confirm: '確認',
  domestic_cancelConfirm: '確認撤回',
  domestic_billNo: '請求書番号',
  domestic_settleAccountTto: '決算先略称',
  domestic_settlementAgent: '代理者',
  domestic_invoiceHeader: '請求書社名',
  domestic_currency: '通貨',
  domestic_chargeAmount: '総額',
  domestic_amount: 'Amount',
  domestic_totalCurrency: '金額と通貨',
  domestic_revenueAndExpenditureType: '収入種類',
  domestic_confirmationStatus: '確認ステータス',
  domestic_invoicingStatus: '発行状態',
  domestic_writeOffStatus: '振込状態',
  domestic_revenueOrExpenditure: 'Revenue Or Expenditure',
  domestic_chargeItem: '請求項目',
  domestic_unit: ' 単位',
  // domestic_amount: 'Amount',
  domestic_unitPrice: '単価',
  domestic_taxIncludedPrice: '税込金額',
  domestic_taxExcludedPrice: '税抜金額',
  domestic_taxRate: '税率',
  domestic_taxAmount: '消費税額',
  domestic_remarks: '備考',
  domestic_billingGroupNo: 'Billing Group No',
  domestic_billingBranchId: 'Billing CMP',
  international_showAllBilling: 'show All Billings',
  international_commissionedChargesOnly: 'Commissioned Charges Only',
  international_add: '新規',
  international_edit: '編集',
  international_delete: 'Delete',
  international_audit: '審査',
  international_invalid: 'Invalid',
  international_agentProfitShareBillNo: '代理シェア請求書',
  international_editAgentBillNo: '相手アカウント編集',
  international_printAllAgentProfitShareBillNo: 'Print All Agent Profit Share Bill No',
  international_billNo: '請求番号',
  international_agentBillNo: 'Agent BillNo',
  international_revenueAndExpenditureType: 'Revenue And Expenditure Type',
  international_settleAccountTo: 'Settle Account To',
  international_settlementAgent: 'Settlement Agent',
  international_currency: ' 通貨',
  international_chargeAmount: 'Charge Amount',
  international_amount: 'Amount',
  international_status: '状態',
  international_billType: 'Bill Type',
  international_invoicingStatus: 'Invoicing Status',
  international_writeOffStatus: 'Clearance Status',
  international_billDtae: '伝票日付',
  international_creator: '作成者',
  international_businessNumber: '業務番号',
  international_billingGroupNo: 'Billing Group No',
  international_revenueOrExpenditure: 'Revenue Or Expenditure',
  international_chargeItem: '請求項目',
  international_taxIncludedPrice: '税込金額',
  international_taxExcludedPrice: '税抜金額',
  international_taxRate: '税率',
  international_taxAmount: '消費税額',
  international_unit: ' 単位',
  // international_amount: 'Amount',
  international_unitPrice: '単価',
  international_remarks: '備考',
  adChargeInfo_prepaid: 'Prepaid',
  adChargeInfo_print: 'Print',
  adChargeInfo_newAdjustment: 'New Adjustment',
  adChargeInfo_editAdjustment: 'Edit Adjustment',
  adChargeInfo_deleteAdjustment: 'Delete Adjustment',
  adChargeInfo_addBoth: 'Add Both',
  adChargeInfo_add: 'Add',
  adChargeInfo_delete: 'Delete',
  adChargeInfo_chargeItem: '請求項目',
  adChargeInfo_settleAccountsTo: '決算勘定',
  adChargeInfo_domesticOrInternational: 'Domestic Or Overseas',
  adChargeInfo_currency: ' 通貨',
  adChargeInfo_unit: ' 単位',
  adChargeInfo_quantity: '数量',
  adChargeInfo_unitPrice: '単価',
  adChargeInfo_exchangeRate: '為替レート',
  adChargeInfo_amount: 'Amount',
  adChargeInfo_remarks: '備考',
  adChargeInfo_billNo: '請求番号',
  adChargeInfo_taxNo: 'Tax No',
  arChargeInfo_theAmountOfWriteOffs: 'Amount Received',
  apChargeInfo_theAmountOfWriteOffs: 'Amount Paid',
  adChargeInfo_collect: 'Collect',
  adChargeInfo_submitCharge: 'Submit Charge',
  adChargeInfo_cancelSubmit: 'Cancel Submit',
  adChargeInfo_status: 'Status',
  adChargeInfo_paymentApplicationNo: 'Payment Application No',
  international_forceDelete: 'Force delete',
  return: 'return',
  Confirm: 'Confirm',
  Cancel: 'Cancel',
  accrualDate: 'accrualDate',
  adjustmentItem: 'adjustment Item',
  adjustmentValue: 'adjustment Value',
  charge_ProvisionedDate: 'Provisioned Date',
  charge_specialUpdate: 'Adjustment of special expenses',
  charge_settleDepartmentPrefix: 'settleDepartment',
  charge_paymentApplicationDateCreated: 'Payment Application Date Created ',
  charge_SapStatus: 'SAP Status',
  finance_ChargeCommit: 'Change order submission',
  separateAllocation: 'Separate Allocation',
  allocationType: 'Allocation Type',
  costSharingValue: 'Cost Sharing Value',
  modifyField: 'Modify Field',
  operationContent: 'Operation content',
  statusAfterOperation: 'Status after operation',
  routeLeader: 'Route Leader',
  selectAdjustmentItem: 'Please select adjustment item',
  businessInfoAdjustedSuccess: 'Business information adjusted successfully',
  apportionedTax: 'Apportioned Tax',
  charge_asyncCharges: 'Cost Synchronization',
  charge_asyncChargeRecords: 'Cost Synchronization Record',
  lockBusinessSuccess: 'The order locking operation succeeded',
  AccountVerifyBusinessSuccess: 'Audit operation succeeded',
  AccrualSucceeded: 'Accrual succeeded',
  charge_asyncChargesToImportJob: 'Synchronize To Import Business',
  charge_syncChargesConfirmStatus: 'Synchronous charge confirmation',
  charge_cancelSyncChargesConfirmStatus: 'Cancel synchronous charge confirmation',
  charge_syncChargesToSI: 'Synchronization of export to import expenses',
  charge_cancelSyncChargesToSI: 'cancel synchronization of export to import expenses',
  charge_paymentAmount: 'EAS Payment Amount',
  expenseSharingReceipt: 'Expense sharing receipt',
  correspondingAllocationBusiness: 'Corresponding allocation business',
  allocateRelatedBusinesses: 'Allocate related businesses',
  BusinessSyncModifyBusinessDate: 'The export business will synchronously modify the business date',
  ImportBusinessSyncModifyBusinessDate: 'The import business will synchronously modify the business date',
  ExportBusinessItemCannotEmpty: 'This item of export business cannot be empty',
  ImportBusinessItemCannotEmpty: 'This item of import business cannot be empty',
  LandTransportationBusinessItemCannotEmpty: 'This item of land transportation business cannot be empty',
  synchronizationFeesToBeProcessed: ' synchronization fees to be processed',
  markAsRead: 'Mark as read',
  fail: 'Fail',
  applyRecallCharge: 'apply recall charge',
  recallState: 'recall state',
  recallCause: 'recall cause',
  youCanOnlyOperateOnConfirmedCharges: 'You can only operate on confirmed charges',
  thereAreCostsThatHaveBeenWithdrawn: 'There are costs that have been withdrawn',
  theFeeHasEnteredTheSettlementProcess: 'The fee has entered the settlement process',
  PleaseSeparateTheFeesForConfirmationAndWithdrawal: 'Please separate the fees for confirmation and withdrawal',
  receivablePayable: 'receivable/payable',
  currency: ' 通貨',
  sender: 'Sender',
  receiver: 'Receiver',
  syncProgress: 'Synchronization Progress',
  processingStatus: 'Processing status',
  sendingTime: 'Sending time',
  auditOperationTime: 'Audit operation time',
  pending: 'Pending',
  alreadyRead: 'Already read',
  notRead: 'Not read',
  businessHasBeenSubmitted: 'Business has been submitted, unable to pass and add fees. If necessary, please contact the business supervisor to cancel the submission.',
  selectBeConfirmedChargeByUs: 'Please select the expense to be confirmed by us',
  selectRejectedChargeByOppositeParty: 'Please select the expense rejected by the opposite party',
  pleaseSaveTheCurrentPageFirst: 'Please save the current page first',
  commissionAmount: 'Commission Amount',
  charge_writeOffDate_ar: 'Received Date',
  charge_writeOffDate_ap: 'Paid Date',
  GenerateVoucher: 'Has voucher been generated',
  CurrencyAccountsReceivable: 'Currency accounts payable:',
  CurrencyAccountsPayable: 'Currency accounts payable:',
  today: 'Today',
  thisMonthEnd: 'This month end',
  previousMonthEnd: 'Previous month end',
  IssueMonthOfYear: 'Issue {1} of {0}',
  QMonthYear: 'Q{1} {0}',
  XYear: '{0} year',
  SongtiSerif: 'Songti, serif',
  TrialBalance: 'Trial Balance',
  BalanceSheetWithContacts: 'Balance Sheet with Contacts',
  StatementOfAccountWithContacts: 'Statement of Account with Contacts',
  SubsidiaryLedger: 'Subsidiary Ledger',
  GeneralLedger: 'General Ledger',
  Receive: 'Receive',
  Pay: 'Pay',
  Transfer: 'Transfer',
  ForeignCurrencyRevaluation: 'Foreign Currency Revaluation',
  RetainedEarnings: 'Retained Earnings',
  Billion: 'Billion',
  Thousand: 'Thousand',
  Hundred: 'Hundred',
  Ten: 'Ten',
  TenThousand: 'Ten Thousand',
  Yuan: 'Yuan',
  Dime: 'Dime',
  Cent: 'Cent',
  FailedObtainCurrentFiscalPeriod: 'Failed to obtain current fiscal period!',
  Total: '合計',
  Quantity: 'Quantity:',
  UnitPrice: 'Unit Price:',
  ForeignCurrency: 'Foreign Currency:',
  UnbalancedDebitAndCreditEntry: 'Unbalanced debit and credit entry!',
  ThisVoucherPleaseEditInModule: 'This voucher is a business voucher\nPlease edit in the "Generate Voucher" module',
  ForeignCurrencyCannotBeEmpty: 'Foreign Currency cannot be empty',
  ClientItemCannotBeEmpty: 'Client for subsidiary item cannot be empty',
  SupplierItemCannotBeEmpty: 'Supplier for subsidiary item cannot be empty',
  StaffItemCannotBeEmpty: 'Staff for subsidiary item cannot be empty',
  ProjectItemCannotBeEmpty: 'Project for subsidiary item cannot be empty',
  DepartmentItemCannotBeEmpty: 'Department for subsidiary item cannot be empty',
  Client: 'Client',
  Supplier: 'Supplier',
  Department: 'Department',
  Staff: 'Staff',
  Project: 'Project',
  Currency: 'Currency:',
  Amount: 'Amount:',
  ExchangeRate: 'Exchange Rate:',
  All: 'All',
  Yes: 'Yes',
  No: 'No',
  Year: 'Year',
  Period: 'Period',
  PleaseSelectVoucherRange: 'Please select voucher range',
  Assets: 'Assets',
  Liabilities: 'Liabilities',
  Equity: 'Equity',
  Cost: 'Cost',
  ProfitAndLoss: 'Profit and Loss',
  ClientSupplier: 'Client/Supplier',
  BalanceInRMB: 'Balance in RMB',
  UnmatchedClientOrSupplier: 'Unmatched client or supplier',
  AddAssetAccount: 'Add Asset Account',
  Add: 'Add',
  Edit: 'Edit',
  Delete: 'Delete',
  AddCashFlowItem: 'Add Cash Flow Item',
  ImportSucceeded: 'Import succeeded',
  DesignSubaccounts: 'Design Subaccounts',
  NeedToExport: 'Need to export',
  NoExportNeeded: 'No export needed',
  SeparatorSettings: 'Separator settings',
  ExportSeparator: 'Export separator',
  Separator: 'Separator:',
  PleaseFinancialYearForReport: 'Please enter the financial year for initializing report.',
  RepeatingDataLossPleaseCaution: 'Repeating initialization may cause data loss, please use with caution.',
  InitializationPleaseCheckAccountSettings: 'Initialization succeeded, please check account settings.',
  InitializationPleaseCheckTheReport: 'Initialization succeeded, please check the report.',
  DetailedEntryRulesConfiguration: 'Detailed entry rules configuration',
  FeeWillBeDeleted: 'Note: {0} fee will be deleted',
  AccountNotFound: 'Account not found',
  Quarter: 'Quarter',
  AccountingVoucher: 'Accounting Voucher',
  StatusUnknown: 'Status unknown',
  N0Year0Period: '{0} year, {1} period',
  DisplayTransactions: ' 取引表示有無',
  EnterBusinessNumberBeforeQuery: 'Please enter the business number before querying',
  SelectNewEncodingType: 'Select new encoding type',
  SelectMatchingPartnerFieldType: 'Select matching partner field type',
  NewEncodingType: 'New encoding type:',
  CustomerCode: 'Customer Code',
  SupplierCode: 'Supplier Code',
  AtLeastOneCustomerAndSupplierCode: 'Check at least one customer code and supplier code',
  MatchPartnerFieldTypes: 'Match Partner Field Types:',
  PartnersCode: 'Partners code',
  PartnersNumber: 'Partners number',
  PartnersChineseName: 'Partners chinese name',
  ImportCustomerAndProviderCode: 'Are you sure to import [{0}] as the customer code and supplier code of this A/C set partner?',
  ImportCustomerCode: 'Are you sure to import [{0}] as the customer code for this A/C set partner?',
  ImportProviderCode: 'Are you sure to import [{0}] as the supplier code for this A/C set partner?',
  ImportCodePenddingTip: 'Importing customer/supplier codes<br>Leaving the current page will not affect data import, and you will be notified after the import is completed.',
  ModifyExpirationDate: 'Modify expiration date',
  ModifyChargeExpirationDate: 'Modify fee expiration date',
  RemoveCountFee: 'Please remove the calculated fees',
  ChargeHqCurrency: 'HQ Currency',
  ChargeHqRate: 'HQ Rate',
  CostType: 'コストタイプ',
  HideForeignCurrencyProfitLoss: 'Do not display foreign currency profit and loss carryover',
  GpExplain: '総利益の説明',
  Peer: '委託先同行有無',
  ProfitRate: 'Profit Rate',
  ArRowsAndApRows: 'AR行／AP行',
  ArIncludeAp: 'ARにAPを含める',
  Allocation: '配分',
  LclTicketsCanNotAudit: '綴り小切手は単独で審査することはできません。マスターチケットを審査してください。',
  SelectedDataJobSubmitNotAllowAudit: '選択したデータの中には、現在のレビュー担当者と同じ業務提出者がいて、レビューは許可されていません。チェックしてください！',
  SelectedDataJobSubmitNotAllowCancelAudit: '選択したデータには、現在のレビュー担当者と同じ送信者がいます。レビューのキャンセルは許可されていません。チェックしてください！',
  SelectedDataChargeByNotAllowCancelAudit: '選択したデータの中には変更書の提出者と現在のレビュー担当者が同じで、レビューは許可されていません。チェックしてください！',
  JobSubmitNotAllowAudit: 'ビジネス提出者と現在のレビュー実施者は同じで、レビューは許可されていません！',
  JobSubmitNotAllowCancelAudit: 'ビジネス提出者は現在のレビュー実施者と同じで、レビューのキャンセルは許可されていません！',
  JobSubmitNotAllowCancelChangeOrder: 'ビジネス提出者は現在のレビュー担当者と同じで、請求変更は許可されていません！',
  ChargeSubmitNotAllowAudit: '費用提出者は現在のレビュー実施者と同じで、レビューは許可されていません！',
  ChargeSubmitNotAllowCancelAudit: '費用提出者は現在のレビュー実施者と同じで、費用レビューのキャンセルは許可されていません！',
  ChargeSubmitNotAllowCancelChangeOrder: '費用提出者は現在のレビュー実施者と同じで、変更請求レビューは許可されていません！',
  AdditionalCostRemarks: '追加費用コメント',
  AdditionalCostRemarksContent: '追加料金備考内容',
  JobSubmitNotAllowCancelAdjustCosts: 'ビジネス提出者は現在のレビュー担当者と同じで、料金の調整は許可されていません！'
}
